import * as React from 'react';

import * as styles from './DocumentMessage.css';
import { EOutcomingStatus, TOutcomingStatus } from '../../types/messages';
import { ChatFileLoader } from '../ChatFileLoader';
import { FileMessageInfo } from '../FileMessageInfo';

type TDocumentMessageProps = {
  isOutcoming: boolean;
  messageStatus: TOutcomingStatus;
  name: string;
  size?: string;
  src: string | null;
  onCancel: VoidFunction;
  onReload: VoidFunction;
};

export const DocumentMessage: React.FC<TDocumentMessageProps> = ({
  isOutcoming,
  messageStatus,
  name,
  size,
  src,
  onCancel,
  onReload,
}) => {
  const isMessageLoading = messageStatus === EOutcomingStatus.Pending;
  const isMessageFailed = messageStatus === EOutcomingStatus.Failed;

  return (
    <div className={styles['container']} data-name="DocumentMessage">
      <ChatFileLoader
        src={src}
        isLoading={isMessageLoading}
        isOutcoming={isOutcoming}
        withCancel={isMessageLoading}
        withSave={Boolean(src)}
        withReload={isMessageFailed}
        withFileIcon={!isMessageFailed && !isMessageLoading && !src}
        onCancel={onCancel}
        onReload={onReload}
      />
      <FileMessageInfo name={name} size={size} src={src} isOutcoming={isOutcoming} />
    </div>
  );
};
